export const Header = {
  HamburgerBtn: 'navigation-hamburger-btn',
} as const;
